import { createRouter, createWebHistory } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'
import generatedRoutes from 'virtual:generated-pages'
import { useTalleresStore } from '@/stores/talleres'
import { useAuthStore } from '@/stores/auth'
import { miUsuario } from '@/services/usuarios'

// Process routes with layouts
const routes = setupLayouts(generatedRoutes)

routes.push(
  {
    path: '/admin/gestion-talleres',
    component: () => import('@/pages/admin/gestion-talleres/index.vue'),
    meta: {
      title: 'Crear Taller',
      requiresAuth: true
    }
  },
  {
    path: '/admin/gestion-talleres/lista',
    component: () => import('@/pages/admin/gestion-talleres/lista.vue'),
    meta: {
      title: 'Lista de Talleres',
      requiresAuth: true
    }
  },
  {
    path: '/admin/gestion-talleres/editar/:id',
    component: () => import('@/pages/admin/gestion-talleres/editar/[id].vue'),
    meta: {
      title: 'Editar Taller',
      requiresAuth: true
    }
  },
  {
    path: '/docentes/:taller/estadisticas',
    component: () => import('@/pages/docentes/[taller]/estadisticas.vue'),
    meta: {
      title: 'Estadísticas del Taller',
      requiresAuth: true,
      layout: 'docentes'
    }
  },
  {
    path: '/docentes/:taller/mis-alumnos',
    component: () => import('@/pages/docentes/[taller]/mis-alumnos.vue'),
    meta: {
      title: 'Mis Alumnos',
      requiresAuth: true,
      layout: 'docentes'
    }
  },
  {
    path: '/docentes/:taller/inicio',
    component: () => import('@/pages/docentes/[taller]/inicio.vue'),
    meta: {
      title: 'Detalle del Taller',
      requiresAuth: true,
      layout: 'docentes'
    }
  },
  {
    path: '/docentes/:taller',
    redirect: to => ({ path: `/docentes/${to.params.taller}/inicio` })
  }
)

// Create router
const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

// Necesito agregar una ruta
// Para el path /virtuales/[autor]/[taller]/anecdotas/[id]
// Si no tiene el id, redirigir a /virtuales/[autor]/[taller]/anecdotas/mia
// Solo para la ruta completa
router.beforeEach((to, from, next) => {
  console.log(to)
  if (
    (to.path === "/virtuales/hernan-casciari/taller-marzo/anecdotas" || to.path === "/virtuales/hernan-casciari/taller-marzo/anecdotas/")

    && !to.params.id) {
    next({ path: "/virtuales/hernan-casciari/taller-marzo/anecdotas/mia" })
  } else {
    next()
  }
})

// Error handler
router.onError((error) => {
  console.error('Vue Router error:', error)
})

// En la configuración del router
router.beforeEach(async (to, from, next) => {
  const talleresStore = useTalleresStore()
  const authStore = useAuthStore()

  // Excluir rutas de inscripciones de la verificación de autenticación
  if (to.path.startsWith('/inscripciones')) {
    next()
    return
  }

  // Verificar autenticación para rutas protegidas
  if (to.meta.requiresAuth || to.path.startsWith('/docente')) {
    // Verificar si el usuario está autenticado
    const isAuthenticated = await authStore.verificarAutenticacion()
    
    if (!isAuthenticated) {
      // Si no está autenticado, redirigir al login con la ruta de retorno
      next({ 
        path: '/ingresar', 
        query: { redirect: to.fullPath }
      })
      return
    }

    // Si la ruta es /docente o comienza con /docente/, verificar si es docente
    if (to.path.startsWith('/docente')) {
      if (!authStore.usuario?.docente) {
        // Si no es docente, redirigir al home
        next({ path: '/' })
        return
      }
    }
  }

  // Si no hay restricciones o se cumplen todas, continuar
  next()
})

export default router